var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainmenuUserManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.455,
    height: 18.473,
    viewBox: "0 0 13.455 18.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mainmenu-user-management",
    transform: "translate(-700.37 -930.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9902",
    "data-name": "Path 9902",
    d: "M759.653,1049.453a20.141,20.141,0,0,1,.223-2.853,4.882,4.882,0,0,1,4.715-3.794q1.8-.042,3.606,0a4.989,4.989,0,0,1,4.89,4.865c.035,1.288.021,2.579-.005,3.868a.669.669,0,0,1-.332.478,12.469,12.469,0,0,1-4.23,1.036,22.237,22.237,0,0,1-8.348-.952.545.545,0,0,1-.464-.657c.024-.661.007-1.324.007-1.986Z",
    transform: "translate(-59.283 -104.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9905",
    "data-name": "Path 9905",
    d: "M794.384,968.992a3.887,3.887,0,0,1-3.819,3.941,3.921,3.921,0,1,1,3.819-3.941Z",
    transform: "translate(-83.357 -34.813)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainmenuUserManagement);
export default __webpack_public_path__ + "static/media/Mainmenu-user-management.c0801e74505949437b63f7dc421e516d.svg";
export { ForwardRef as ReactComponent };